import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';

import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { NativeLayerService } from '@ildes/services/native-layer.service';
import { environment } from '../../environments/environment';
import { HttpErrorResponse } from '@angular/common/http';

export class ExtendedHttpErrorResponse extends HttpErrorResponse {
  method?: string;
}
const WHITE_LIST = ['/public', '/session', '/version'];

const HOST = environment.host;

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  constructor(private native: NativeLayerService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let headers = req.headers;

    if (
      WHITE_LIST.filter((signature) => req.url.indexOf(signature) >= 0).length
    ) {
      return next.handle(req.clone({ headers }));
    }
    // TODO: bindear con una lista de hosts genérica, como en @223344
    if (req.url.indexOf(HOST) <= 0) {
      return next.handle(req);
    }

    const userAgent = {
      operatingSystem: this.operatingSystem,
      device: this.device,
      engine: this.engine,
      version: environment.releaseVersion,
    };
    headers = headers.set('ildes-user-agent', JSON.stringify(userAgent));

    const authReq = req.clone({
      headers,
    });

    return next.handle(authReq).pipe(
      tap((res: any) => {
        if (res.type === 0) {
          return;
        }
        const jwt = res.headers.get('jwt');

        if (!jwt) {
          return;
        }

        sessionStorage.setItem('token', jwt);
        localStorage.setItem('token', jwt);
      }),
      catchError((error) =>{
        const extendedError = new ExtendedHttpErrorResponse(error);

        extendedError.method = req.method;
        return throwError(extendedError);
      })
    );
  }

  get operatingSystem() {
    try {
      if (this.native.isNative) {
        const device = this.native.getDeviceInfo();

        return `${device.operatingSystem} ${device.osVersion}(${device.androidSDKVersion})`;
      } else {
        return navigator.userAgent.split('(')[1].split(')')[0].split(';')[1];
      }
    } catch {
      return '-';
    }
  }

  get device() {
    try {
      if (this.native.isNative) {
        const device = this.native.getDeviceInfo();

        return `${device.name} ${device.manufacturer}`;
      } else {
        return navigator.userAgent.split('(')[1].split(')')[0].split(';')[0];
      }
    } catch {
      return '-';
    }
  }

  get engine() {
    try {
      if (this.native.isNative) {
        const device = this.native.getDeviceInfo();

        return `webview ${device.webViewVersion}`;
      } else {
        return navigator.userAgent.split('(').slice(-1)[0];
      }
    } catch {
      return '-';
    }
  }
}
